import { Text } from '@react-pdf/renderer'
import React from 'react'
import { cn } from '~/lib'
import { tw } from './tw'

export default function PdfBadge({
  className,
  children,
}: {
  className?: string
  children: React.ReactNode
}) {
  return (
    <Text
      style={tw(
        cn(
          className,
          'rounded-sm px-2 pt-px font-sans text-[12px] leading-none'
        )
      )}>
      {children}
    </Text>
  )
}
